import SocketIOClient from 'socket.io-client'
let isConnected = false
// const socket = SocketIOClient("https://chat.supportroom.com:3000",{
// const socket = SocketIOClient("https://chat.trisec.io:3000/", { // Stage
const socket = SocketIOClient("https://control.mysupportroom.com:3000/", { // Prod
  transports: ['websocket']
});
socket.on('connect', () => {
  isConnected = true
})

socket.on('disconnect', () => {
  isConnected = false
})

export { socket, isConnected }
